import React, { useState, useEffect } from "react";
import apiClient from "../../AppClient";
import { Container, Form, Button, Table, Alert, Spinner } from "react-bootstrap";

const MostSoldReport = () => {
  const [reports, setReports] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [nameFilter, setNameFilter] = useState("");

  const fetchReports = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get("/transactions/reports/most-sold-and-purchased-products");
      console.log("API Response:", response.data); // Debug: Log the response data
      
      // Filter out entries where both sale_count and purchase_count are null
      const validReports = response.data.filter(
        report => report.sale_count !== null || report.purchase_count !== null
      );
      
      setReports(validReports);
      setError(null);
    } catch (error) {
      console.error("API Error:", error); // Debug: Log the error
      setError(error.response?.data?.detail || "فشل في جلب تقرير المنتجات الأكثر مبيعًا وشراء.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  const filteredReports = reports.filter((report) =>
    nameFilter ? report.product_name.toLowerCase().includes(nameFilter.toLowerCase()) : true
  );

  const handleRefresh = () => {
    fetchReports();
  };

  return (
    <Container
      style={{
        direction: "rtl",
        textAlign: "right",
        padding: "20px",
        fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        color: "black",
        backgroundColor: "white",
      }}
    >
      <h1 style={{ color: "darkgreen", marginBottom: "20px" }}>تقرير المنتجات الأكثر مبيعًا وشراء</h1>
      
      {/* Controls */}
      <div style={{ display: "flex", marginBottom: "20px", gap: "10px" }}>
        <Form.Control
          type="text"
          placeholder="ترتيب حسب اسم المنتج"
          value={nameFilter}
          onChange={(e) => setNameFilter(e.target.value)}
          style={{ maxWidth: "250px" }}
        />
        <Button
          variant="outline-secondary"
          onClick={() => setNameFilter("")}
          style={{ border: "1px solid darkgreen", color: "darkgreen" }}
        >
          مسح الترتيب
        </Button>
        <Button
          variant="success"
          onClick={handleRefresh}
          style={{ marginRight: "10px" }}
        >
          تحديث البيانات
        </Button>
      </div>

      {/* Error Message */}
      {error && <Alert variant="danger">{error}</Alert>}

      {/* Loading Spinner */}
      {loading ? (
        <div className="text-center">
          <Spinner animation="border" role="status" style={{ color: "darkgreen" }}>
            <span className="visually-hidden">جاري التحميل...</span>
          </Spinner>
        </div>
      ) : (
        /* Report Table */
        <Table hover responsive>
          <thead style={{ backgroundColor: "darkgreen", color: "white" }}>
            <tr>
              <th>#</th>
              <th>اسم المنتج</th>
              <th>عدد المبيعات</th>
              <th>عدد الشراء</th>
            </tr>
          </thead>
          <tbody>
            {filteredReports.length === 0 ? (
              <tr>
                <td colSpan="4" className="text-center">لم يتم العثور على بيانات</td>
              </tr>
            ) : (
              filteredReports.map((report, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{report.product_name}</td>
                  <td>{report.sale_count !== null ? report.sale_count : "غير متاح"}</td>
                  <td>{report.purchase_count !== null ? report.purchase_count : "غير متاح"}</td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      )}
    </Container>
  );
};

export default MostSoldReport;